import { render } from "./PeripheralSection.vue?vue&type=template&id=436edcd2"
import script from "./PeripheralSection.vue?vue&type=script&lang=js"
export * from "./PeripheralSection.vue?vue&type=script&lang=js"

import "./PeripheralSection.vue?vue&type=style&index=0&id=436edcd2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__